import * as React from "react";
const LinkedIn = (props) => (
  <svg
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[48px] h-[48px] lg:w-[56px] lg:h-[56px] group"
  >
    <circle
      cx="28"
      cy="28"
      r="27.5"
      stroke="#1F2022"
      className="group-hover:fill-primary"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 19.67A1.67 1.67 0 0 1 19.67 18h16.657A1.67 1.67 0 0 1 38 19.67v16.657A1.67 1.67 0 0 1 36.328 38H19.671A1.67 1.67 0 0 1 18 36.328V19.671Zm7.916 5.955h2.709v1.36c.39-.781 1.39-1.485 2.893-1.485 2.881 0 3.564 1.557 3.564 4.415v5.292h-2.916v-4.642c0-1.627-.39-2.545-1.383-2.545-1.378 0-1.95.99-1.95 2.546v4.641h-2.917v-9.582Zm-5 9.458h2.917V25.5h-2.917v9.582Zm3.334-12.708a1.875 1.875 0 1 1-3.749.082 1.875 1.875 0 0 1 3.749-.082Z"
      fill="#1F2022"
      className="group-hover:fill-white"
    />
  </svg>
);
export default LinkedIn;
